import htmlLogo from './assets/html.png';
import cssLogo from './assets/css.png';
import jsLogo from './assets/js.png';
const data = [
  {
    id: 1,
    name: "HTML",
    text: "Welcome to Our HTML Course",
    // img: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/512px-HTML5_Badge.svg.png",
    img: htmlLogo,
  },
  {
    id: 2,
    name: "CSS",
    text: "Welcome to Our CSS Course",
    // img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/512px-CSS3_logo.svg.png",
    img: cssLogo,
  },
  {
    id: 3,
    name: "JAVASCRIPT",
    text: "Welcome to Our JS Course",
    // img: "https://www.seekpng.com/png/full/80-803501_javascript-logo-logo-de-java-script-png.png",
    img: jsLogo,
  },
];

export default data;
